import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";
export const RNHLugarOrganigramaGet = async (credentials, data = {}) => {
  const body = {
    service: "RNHLugarOrganigramaGet",
    params: {
      rnhEstablecimientoCod: data?.establecimientoCod || null,
      rnhCargoCod: data?.cargoCod || null,
      rnhTipoComponenteCod: data?.componenteCod || null,
      listAll: data?.listAll ?? null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
